import {ApolloProvider} from '@apollo/client';
import * as React from 'react';

import client from './client';

export const GQLProvider = ({children}: {children: React.ReactNode}) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);
